<template>
	<div>
		<!-- Main -->
		<nav class="uk-navbar-container uk-margin-small-bottom" uk-navbar>
			<div class="uk-navbar-left">
				<span class="uk-navbar-item uk-logo">支社・支店・AMパスワード一括設定</span>
			</div>
			<div class="uk-navbar-right">
				<div class="navbar-item">
					<button class="uk-button uk-text-small uk-button-small uk-button-default"
						@click="clickLogoutButton">ログアウト</button>
				</div>
			</div>
		</nav>
		<div class="uk-container uk-container-expand uk-margin-medium uk-margin-remove-left uk-margin-remove-right">
			<div class="uk-align-right">
				<button class="uk-button uk-button-default" @click="returnButton">戻る</button>
			</div>
		</div>
		<!--/ Main -->
		<div class="uk-container uk-container-expand uk-margin-large-bottom">
			<h1 class="uk-heading-divide ruk-padding uk-text-center">支社・支店・AMパスワード更新</h1>
			<div class="uk-margin uk-padding uk-text-center">
				CSVファイル選択：&emsp;<input id="file" type="file">
			</div>
			<div class="uk-margin uk-padding uk-text-center">
				<button class="uk-button uk-button-default" @click="upload">&emsp;更&emsp;新&emsp;</button>
			</div>
			<div class="uk-margin uk-padding uk-text-center">
				<p>最終更新日時: {{ last_updated | moment }}</p>
			</div>
		</div>
		<div id="progress-import" uk-modal>
			<div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical uk-text-center" :class="visibleStateLoading"><i
					class="fas fa-spinner fa-spin"></i> 更新中...</div>
		</div>
	</div>
</template>

<script>

import CsvImport from '@/api/CsvImport'
import StaffAuth from '@/api/StaffAuth'
import Role from '@/api/Role'
import MainOfficeAuth from '@/api/MainOfficeAuth'
import CallCenterAuth from '@/api/CallCenterAuth'
import BranchOfficeAuth from '@/api/BranchOfficeAuth'
import CgtManageAuth from '@/api/CgtManageAuth'
import Tag from '@/api/Tag'

export default {
	name: 'CgtManageImportBranchOfficePwPage',
	comments: [],
	data () {
		return {
			last_updated: null,
			is_click: false
		}
	},
	filters: {
		moment: function (date) {
			if (date == null) {
				return null
			}
			return moment(date).format('YYYY/MM/DD HH:mm')
		}
	},
	methods: {
		returnButton: function () {
			this.$router.push('/cgt_manage')
			location.reload()
		},
		clickLogoutButton () {
			let self = this

			let return_url = '/cgt_manage/login'

			// StaffAuth.logout().then(function (response) {
			// CallCenterAuth.logout().then(function (response) {
			// BranchOfficeAuth.logout().then(function (responase) {
			// MainOfficeAuth.logout().then(function (response) {
			CgtManageAuth.logout().then(function (response) {
				self.$router.push(return_url)
				location.reload()
			})
			// })
			// })
			// })
			// })
		},
		upload () {
			let self = this
			let params = new FormData()
			params.append('file', $('#file')[0].files[0])
			params.append('target', 'branch_office')

			UIkit.modal('#progress-import', { container: '#app div', bgClose: false }).show()
			self.is_click = true
			CsvImport.importPw(params).then(function (response) {
				let data = response.data.data

				if (response.data.message == 'FAIL') {
					if (data.errors != null) {
						let message = ''
						for (let key in data.errors) {
							if (message !== '') {
								message += '\n'
							}
							let count = data.errors[key].count
							let error_message = data.errors[key].error_message
							message += error_message + ' (' + (count + 1) + '行目)'
						}
						alert(message)
					} else {
						if (data.count > 0) {
							alert(data.error_message + ' (' + (data.count + 1) + '行目)')
						} else {
							alert(data.error_message)
						}
					}
				} else {
					if (data.id_not_found_count > 0) {
						alert('更新が完了しました (' + data.id_not_found_count + '件の存在しないログインIDをスキップ)')
					} else {
						alert('更新が完了しました')
					}
					self.last_updated = data.time
				}
				self.is_click = false
				UIkit.modal('#progress-import').hide()
			}, function () {
				alert('インポート処理でエラーが発生しました。')
				UIkit.modal('#progress-import').hide()
				self.is_click = false
			})
		}
	},
	created () {
	},
	beforeMount () {
	},
	mounted () {
		let self = this
		self.last_updated = null

		Role.show().then(function (response) { // 権限取得
			let data = response.data

			if (data.data.is_cgt_manage != true) { // 権限が無い場合
				self.$router.push('/')
			}
		})

		let params = new URLSearchParams()
		params.append('key', 'last_import_branch_office_pw_time')

		Tag.one(params).then(function (response) {
			if (response.data.data !== null) {
				self.last_updated = moment(response.data.data.value).format('YYYY-MM-DD HH:mm:ss')
			}
		})
	}

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/page/CgtManageImportBranchOfficePwPage.vue